import { render } from "./CaiNiLike.vue?vue&type=template&id=3761ff32&scoped=true"
import script from "./CaiNiLike.vue?vue&type=script&lang=js"
export * from "./CaiNiLike.vue?vue&type=script&lang=js"

import "./CaiNiLike.vue?vue&type=style&index=0&id=3761ff32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3761ff32"]])

export default __exports__